import React, { useState } from 'react';
import './ReviewModal.css';
// import toast from 'react-hot-toast';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';

const ReviewModal = ({ productId, onClose }) => {
  const [rating, setRating] = useState(0);
  const [reviewText, setReviewText] = useState('');
    const [loading, setLoading] = useState(false); // Loader state


  

  const handleSubmit = async () => {
    try {
      const response = await fetch(`https://riymay.com/api/v1/user/products/${productId}/reviews`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('userToken')}`,
        },
        body: JSON.stringify({ rating, review: reviewText}),
      });

      const data = await response.json();

      if (!response.ok) {
        // Handle specific errors
        if (data.error === "Missing rating. Please add a rating") {
          toast.error(data.error, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            className: "custom-toast",
            bodyClassName: "custom-toast-body",
          });
          return; // Exit the function
        }
  
        if (data.message === "User has already submitted a review.") {
          toast.error(data.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            className: "custom-toast",
            bodyClassName: "custom-toast-body",
          });
          return; // Exit the function
        }
  
        // Generic error handling
        toast.error(data.message || "Please Add Rating.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          className: "custom-toast",
          bodyClassName: "custom-toast-body",
        });
        return; // Exit the function
      }
  
      // Success handling
      toast.success("Review submitted successfully!", {
        position: "top-right",
        autoClose: 3000, // Reduced to 3 seconds for better UX
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        className: "custom-toast",
        bodyClassName: "custom-toast-body",
      });

      onClose(); // Close the modal or perform any other action
    } catch (error) {
     
      toast.error(error.message || "Please Add Rating.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        className: "custom-toast",
        bodyClassName: "custom-toast-body",
      });
    }
  };

  return (
    <div className="review-modal">

      <div className="review-modal-content">
        <h3>Write a Review</h3>
        <h3>How satisfied are you with this Product?</h3>
        <p></p>
        <div className="review-modal-stars">
          <p>Rate this product </p>
          {[1, 2, 3, 4, 5].map((star) => (
            <span
              key={star}
              className={`star ${star <= rating ? 'selected' : ''}`}
              onClick={() => setRating(star)}
            >
              ★
            </span>
          ))}
        </div>
        <textarea
          value={reviewText}
          onChange={(e) => setReviewText(e.target.value)}
          placeholder="Write your review here..."
        />
        <div className="review-modal-buttons">
          <button onClick={handleSubmit}>Submit</button>
          <button onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default ReviewModal;
